import React from 'react'
import './ForgotPassword.scss';
import DecentroBanner from '../../components/Shared/DecentroBanner/DecentroBanner.js';
import InputField from '../../components/Shared/InputField/InputField.js';
import BlueButton from '../../components/Shared/BlueButton/BlueButton.js';
import StickyFooter from '../../components/StickyFooter/StickyFooter.js';

let label = { 'light': "We’re here", 'bold': "for you!" };

const ForgotPassword = () => {
    return (
        <React.Fragment>
            <div className="fp">
                <DecentroBanner label={label} />
                <div className="fp-section">
                    <div className="form-section">
                        <img src="./images/logo.svg" alt="logo" />
                        <h1>Enter your email and we will send you a password reset link.</h1>
                        <div className="input-section">
                            <InputField type="email" placeholder="E-Mail" />
                            <BlueButton text="Send Request"
                                clickevent={() => {
                                    //
                                }} />
                        </div>
                    </div>
                </div>
            </div>
            <StickyFooter />
        </React.Fragment>
    )
}

export default ForgotPassword;